




































import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'FormBuilder'

  vue:
    props: ['form', 'fieldLibrary', 'fieldGroups']

    components: {
      FormField,
    }

    data: ->
      selectedFieldKey: null
      availableGroups: {}

    computed:
      data: -> @form.data || {}
      fields: -> @form.fields || {}
      errors: -> @form.errors || {}

    mounted: ->
      @initializeFields()

    methods:
      initializeFields: ->
        for groupKey, group of @fieldGroups
          continue if groupKey.startsWith '_'
          for key in group.fieldKeys
            continue if @isEmptyValue @data[key]
            @fields[key] = @fieldLibrary.fields[key]
        @updateAvailableGroups()

      hiAddField: (keys) ->
        [groupKey, fieldKey] = keys.split '.'
        @form.fields[fieldKey] = @fieldLibrary.fields[fieldKey]
        @selectedFieldKey = null
        @updateAvailableGroups()

      hiRemoveField: (fieldKey) ->
        @removeField fieldKey
        @updateAvailableGroups()

      removeField: (fieldKey) ->
        { fields, errors } = {...@form}
        delete fields[fieldKey]
        delete errors[fieldKey]
        @form.fields = fields
        @form.errors = errors

      updateAvailableGroups: ->
        groups = {}
        for groupKey, group of @fieldGroups
          continue if groupKey.startsWith '_'
          groups[groupKey] ||= { ...group, fields: {} }
          for fieldKey in group.fieldKeys
            continue if @fields[fieldKey]
            field = @fieldLibrary.fields[fieldKey]
            groups[groupKey].fields[fieldKey] = field if field
          delete groups[groupKey] unless Object.values(groups[groupKey].fields).length
        @availableGroups = groups

    watch:
      fieldLibrary: (fieldLibrary) ->
        @form.fields[key] = @fieldLibrary.fields[key] for key of @form.fields

export default VueOptions.vue settings
